<template>
  <q-select :options="options"
            v-model="item[prop]"
            use-input
            dense
            filled
            map-options
            options-dense
            ref="formInput"
            emit-value
            :clearable="!required"
            :label="label"
            option-label="full_name"
            @filter="filterFn"
            @input="$emit('input', $event)"
            option-value="id"
            :rules="required ? requiredRules : []"
  />
</template>

<script>
export default {
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Select User",
    },
    required: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    onlyAdmins: {
      default: false
    },
    prop: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      options: [],
      allOptions: []
    }
  },
  name: "UserSelect",
  mounted() {
    this.get()
  },
  methods: {
    validate(...args){
      // https://github.com/quasarframework/quasar/issues/7305#issuecomment-650058607
      return this.$refs.formInput.validate(...args);
    },
    filterFn (val, update) {
      if (val === '') {
        update(() => {
          this.options = this.allOptions

          // with Quasar v1.7.4+
          // here you have access to "ref" which
          // is the Vue reference of the QSelect
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.options = this.allOptions.filter(v => v.full_name.toLowerCase().indexOf(needle) > -1)
      })
    },
    get(){
      this.axiosGet('/users/list', r => {

        if(this.onlyAdmins){
          this.allOptions = r.data.filter(u => u.is_admin)
        } else {
          this.allOptions = r.data
        }
      }, false)
    }
  },
}
</script>

<style scoped>

</style>
